<router-outlet></router-outlet>

<ng-template #modalContent>
  <div mat-dialog-content>
    <h1>This is not a production environment</h1>
  </div>
</ng-template>
